export const getUser = (store) => store.user
export const getTheme = (store) => store.theme